import { useCallback, useMemo } from "react";

import { AIRPORT_LIST, COUNTRY_SUBD_LIST, REGION_LIST } from "@/constants/airport";
import { filterAirport } from "@/utils/index";

export type LocationOption = {
  code: string;
  name: string;
  showName?: string;
  type: string;
};

export enum LocationEnum {
  REGION = "1",
  COUNTRY = "2",
  CITY = "3",
  AIRPORT = "4",
}

export const locationTextMap: Record<string, string> = {
  [LocationEnum.REGION]: "Region",
  [LocationEnum.COUNTRY]: "Country & Subdivision",
  [LocationEnum.CITY]: "City",
  [LocationEnum.AIRPORT]: "Airport",
};

const useLocationFilter = () => {
  const regions = useMemo(() => {
    const list = REGION_LIST.map((ele) => {
      return {
        ...ele,
        type: LocationEnum.REGION,
      };
    });

    return list;
  }, []);

  const countrys = useMemo(() => {
    const list = COUNTRY_SUBD_LIST.map((ele) => {
      return {
        ...ele,
        type: LocationEnum.COUNTRY,
      };
    });

    return list;
  }, []);

  const locationFilter = useCallback(
    (keywords: string) => {
      const keyword = keywords.trim().toUpperCase();

      if (keyword.length === 0) {
        return [
          ...regions.slice(0, 3),
          ...countrys.slice(0, 3),
          ...AIRPORT_LIST.slice(0, 3).map((ele) => {
            return {
              code: ele.iata,
              name: ele.name,
              type: LocationEnum.AIRPORT,
            };
          }),
        ];
      }

      const filterRegions = regions
        .filter(
          (ele) =>
            ele.name.toUpperCase().indexOf(keyword) !== -1 ||
            ele.code.toUpperCase().indexOf(keyword) !== -1
        )
        .slice(0, 3);

      const filterCountrys = countrys
        .filter(
          (ele) =>
            ele.name.toUpperCase().indexOf(keyword) !== -1 ||
            ele.code.toUpperCase().indexOf(keyword) !== -1
        )
        .slice(0, 5);

      const filterAirports = filterAirport(keywords, { enableCustomCode: false }).map((ele) => {
        if (typeof ele !== "string") {
          return {
            code: ele.iata,
            name: ele.name,
            type: LocationEnum.AIRPORT,
          };
        }
        // 没啥用，避免ts类型检查报错
        return {
          code: ele,
          name: ele,
          type: LocationEnum.AIRPORT,
        };
      });

      return [...filterRegions, ...filterCountrys, ...filterAirports];
    },
    [regions, countrys]
  );

  return {
    locationFilter,
  };
};

export default useLocationFilter;
